import { atom, useRecoilState, useResetRecoilState } from 'recoil';

import { getLoginInform } from 'function/login';

/**
 * 공장 선택
 */
// variable
const { fatoryCodeSeq } = getLoginInform();

// atom
const checkPlantState = atom({
  key: 'checkPlantState',
  default: [fatoryCodeSeq]
});

// hook
function useCheckPlantState() {
  const [checkPlant, setCheckPlant] = useRecoilState(checkPlantState);
  const resetCheckPlant = useResetRecoilState(checkPlantState);

  return {
    checkPlant,
    setCheckPlant,
    resetCheckPlant
  };
}

export default useCheckPlantState;
